import { debounce } from "lodash";
import { useCallback } from "react";

export const useDebounce = (callback = [], time = 500) => {
  const debounceFunction = useCallback(debounce(callback, time));
  return debounceFunction;
};

